<!--
  Esta es la plantilla que se usa para las páginas que pertenecen al panel
-->
<template>
  <v-main class="fondo">
    <v-overlay 
      v-model="activarIndicadorEspera" 
      z-index= "999999"> <!-- por encima de todas las ventanas -->
      <v-progress-circular  
        size="120"
        width="12"                       
        color="red"
        indeterminate
        justify="center" 
        align="center">
      </v-progress-circular>
    </v-overlay> 

    <!-- menu lateral / drawer -->

    <v-navigation-drawer v-model="menuLateral" fixed app >
      <v-list-item>
        <v-list-item-avatar>
          <v-img src="@/assets/avatar.png"></v-img>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>{{this.$store.state.operador.nombre}}</v-list-item-title>
          <v-list-item-subtitle>{{this.$store.state.operador.rol}}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense>
        <span v-for="(elemento, i) in elementosMenuOperador" :key="elemento.titulo">
          <v-divider v-if="i>0 && elementosMenuOperador[i-1].seccion != elementosMenuOperador[i].seccion" class="my-2" />
          <v-list-item link :to="elemento.ruta">
            <v-list-item-icon class="mr-3">
              <v-icon>{{ elemento.icono }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ elemento.titulo }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </span>
      </v-list>
    </v-navigation-drawer>

    <!-- app bar -->

    <v-app-bar color="#b2d7d8">
      <v-app-bar-nav-icon @click="menuLateral=!menuLateral"></v-app-bar-nav-icon>
      <img id="logoPanel" v-if="$store.state.operador.empresaInquilina.urlLogo" :src="$store.state.operador.empresaInquilina.urlLogo" style="vertical-align: middle; width: auto; height: auto; max-width: 100%; max-height: 30px; margin-bottom: 8px"/>
      <img v-else :src="`${$global.ruta}/${$global.URLParams}.png`" 
                  @error="$global.errorCargandoLogotipo"
                  style="margin-top: 5px; margin-left: 5px; max-height: 40px" />
      <v-spacer></v-spacer>
      <v-toolbar-title>
        <router-link style="text-decoration: none; color: inherit" to="/panel">

          <div class="titulo mt-2">
          <span style="font-family: Consolas; letter-spacing: -0.5px; font-size: 22px; font-weight: bold;">  Validador de descuentos web</span>
         
          </div>
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon style="margin-right: 5px" v-bind="attrs" v-on="on" @click="cerrarSesion()">
            <v-icon>mdi-logout-variant</v-icon>
          </v-btn>
        </template>
        Cerrar sesión
      </v-tooltip>
    </v-app-bar>

    <!-- mostrar mensaje de error de comunicaciones/descuento no seleccionado -->
    <template v-if="alertaDescuentos.mostrar" > 
        <v-alert
              :value="alertaDescuentos.mostrar"
              :color="alertaDescuentos.color"
              dark
              border="top"
              :icon="alertaDescuentos.icono"
              transition="scale-transition"
        >
          {{ this.alertaDescuentos.texto }}
        </v-alert>     
    </template>

    <!-- router view -->    
    <v-scroll-x-transition hide-on-leave>
      <router-view />
    </v-scroll-x-transition>
    <div style="height: 65px"></div>





    <!-- pie de la vista -->

    <v-footer absolute padless color="#b2d7d8">
      <v-col class="text-center" cols="12">
        {{ new Date().getFullYear() }} —
        <strong>EQUINSA Parking</strong>
      </v-col>
    </v-footer>

  </v-main>
</template>

<script>
import { mapState } from "vuex";
import router from '@/router'
// comunicacion HTTP con RestApi
import axios from "axios"
import { URL_BASE_API } from '@/api.js'

export default {
  components: { },
  computed: {
    ...mapState(["operador"]),
    elementosMenuOperador() {
      return this.elementosMenu.filter((elemento) =>
        elemento.atributoRolOperadorNecesario
          ? this.operador.atributosRol.includes(
              elemento.atributoRolOperadorNecesario
            )
          : true
      );
    },
  },
  data: () => ({
    menuLateral: undefined,
    visible: undefined,
    elementosMenu: [
      {
        seccion: 1,
        titulo: "Descuentos",
        icono: "mdi-percent",
        ruta: "/panel/gestionDescuentos",
        atributoRolOperadorNecesario: "des",
      },
      {
        seccion: 2,
        titulo: "Instalaciones",
        icono: "mdi-parking",
        ruta: "/panel/gestionInstalaciones",
        atributoRolOperadorNecesario: "ins",
      },
/*      {
        seccion: 2,
        titulo: "Parámetros de configuración",
        icono: "mdi-application-cog",
        ruta: "/panel/parametrosConfiguracion",
        atributoRolOperadorNecesario: "parcon",
      },*/
      {
        seccion: 3,
        titulo: "Empresas inquilinas",
        icono: "mdi-vector-square",
        ruta: "/panel/empresasInquilinas",
        atributoRolOperadorNecesario: "empinq",
      },
      {
        seccion: 3,
        titulo: "Gestión de operadores",
        icono: "mdi-account-key",
        ruta: "/panel/gestionOperadores",
        atributoRolOperadorNecesario: "gesope",
      },
      {
        seccion: 3,
        titulo: "Listado descuentos vinculados",
        icono: "mdi-clipboard-search-outline",
        ruta: "/panel/descuentosVinculados",
        atributoRolOperadorNecesario: "desvin",
      },
      {
        seccion: 3,
        titulo: "Registro de auditoría",
        icono: "mdi-clipboard-search-outline",
        ruta: "/panel/registroAuditoria",
        atributoRolOperadorNecesario: "regaud",
      }

    ], // fin elementosMenu

    // ventana de aviso de errores de comunicación al obtener la lista de descuentos
    alertaDescuentos: {
        mostrar: false,
        color: 'red',
        texto: '',
        icono: 'mdi-exclamation'
    }, //fin objeto alertaDescuentos

    // control de la visualizacion del indicador de espera 
    activarIndicadorEspera: false,
  
  }), // fin data


  methods: {

    async cerrarSesion() {
      this.$store.dispatch("CERRAR_SESION");
    }, // fin metodo cerrarSesion

    obtenerDescuentosVinculables: function(){
        console.log('Consulta obtenerDescuentosVinculables');

        if (this.$store.state.operador.instalacion.codinsclo == null)
          return;

        this.activarIndicadorEspera = true;

        var parametros= {
          'codinsclo': this.$store.state.operador.instalacion.codinsclo
        };

        const cabeceras = {
        };

        console.log(parametros);

        axios
          .get( URL_BASE_API + '/EPCloud/obtenerDescuentosVinculables', 
                { params: parametros,
                  headers:cabeceras
                })
          .then(response => {
            console.log('Respuesta obtenerDescuentosVinculables');
            console.log(response.data.filas);
            this.alertaDescuentos.mostrar = false;
            this.activarIndicadorEspera = false;

            localStorage.setItem ('descuentos_vinculables', JSON.stringify (response.data.filas));
            
            if (this.$store.state.operador.atributosRol.includes('des')){        
              router.push ("/panel/gestionDescuentos");
            }
          })
          .catch(error => {
              console.log('Error obtenerDescuentosVinculables')
              console.log(error);

              this.activarIndicadorEspera = false;
              this.alertaDescuentos.mostrar = true;
              this.alertaDescuentos.texto = error;      
          })
          .finally(() => { 
            console.log('Final obtenerDescuentosVinculables');
          })
    }, // fin metodo obtenerDescuentosVinculables



  }, // fin methods

  mounted () {
    /* consulto al parking por sus descuentos vinculables.
       Esto es independiente del rol del usuario logado */
    this.obtenerDescuentosVinculables();

    this.visible = !this.$store.state.operador.atributosRol.includes('des');
    this.menuLateral = !this.$store.state.operador.atributosRol.includes('des');
    

  } // fin mounted  
};
</script>

<style>
</style>
